export const REJECT_RECHARGE_REQUEST = "REJECT_RECHARGE_REQUEST";
export const REJECT_RECHARGE_SUCCESS = "REJECT_RECHARGE_SUCCESS";
export const REJECT_RECHARGE_FAILURE = "REJECT_RECHARGE_FAILURE";
export const REJECT_RECHARGE_RESET = "REJECT_RECHARGE_RESET";
export const rejectRechargeRequest = (payload) => ({
    type: REJECT_RECHARGE_REQUEST,
    payload,
});
export const rejectRechargeSuccess = (payload) => ({
    type: REJECT_RECHARGE_SUCCESS,
    payload,
});
export const rejectRechargeFailure = (payload) => ({
    type: REJECT_RECHARGE_FAILURE,
    payload,
});
export const rejectRechargeReset = () => ({
    type: REJECT_RECHARGE_RESET,
});
